import { actionChannel, call, put, takeEvery } from "redux-saga/effects";

import {
    POST_DYNATRACE_ENABLE_DISABLE_ALERTS,
    POST_DYNATRACE_CREATE_RESOURCE_ALERTS,
    POST_DYNATRACE_CREATE_DYNAMIC_ALERT,
    GET_DYNATRACE_ALERTS,
    GET_DYNATRACE_DYNAMIC_ALERTS,
    GET_DYNATRACE_MISSING_DYNAMIC_ALERTS,
    GET_DYNATRACE_DEFAULT_THRESHOLD,
    GET_DYNATRACE_RESOURCE_BY_ID,
    GET_DYNATRACE_RESOURCE_DEFAULT_THRESHOLD_BY_ID,
    POST_DYNATRACE_ALERT,
    GET_DYNATRACE_MISSING_ALERT_BY_RESOURCE_ID,
    GET_DYNATRACE_ALL_RESOURCE_ALERTS_PAGE,
    GET_DYNATRACE_ALL_RESOURCE_ALERTS_COUNT_PAGE,
    POST_DYNATRACE_SERVICE_MAPPING,
    POST_DYNATRACE_RESOURCE_OPSGENIE_TEAM_MAPPING,
    POST_DYNATRACE_RESOURCE_PAGERDUTY_SERVICE_MAPPING,
    GET_ALL_ORG_DYNATRACE_RESOURCE_TYPES,
    GET_DYNATRACE_RESOURCES,
    GET_RESCAN_STATUS_DYNATRACE,
    POST_UPDATE_DYNATRACE_THRESHOLD,
    POST_ENABLE_DISABLE_DYNATRACE_THRESHOLD, GET_DYNATRACE_RESCAN,
    GET_DYNATRACE_MISSING_ALERTS_BY_RESOURCE_ID,
    GET_DYNATRACE_THRESHOLD,
    GET_DYNATRACE_ALL_USER_ACTIONS,
    GET_DYNATRACE_ALL_KEY_USER_ACTIONS,
    POST_CREATE_KEY_USER_ACTION
} from "./actionTypes";

import {
    getDynatraceAllResourceAlertsPageFail,
    getDynatraceAllResourceAlertsPageSuccess,
    getDynatraceAllResourceAlertsCountPageFail,
    getDynatraceAllResourceAlertsCountPageSuccess,
    getAllOrgDynatraceResourceTypesSuccess,
    getAllOrgDynatraceResourceTypesFail,
    getDynatraceRefreshSuccess,
    getDynatraceRefreshFail,
    getRescanStatusDynatraceSuccess,
    getRescanStatusDynatraceFail,
    postDynatraceServiceMappingFail,
    postDynatraceServiceMappingSuccess,
    postDynatraceResourceOpsGenieTeamMappingSuccess,
    postDynatraceResourceOpsGenieTeamMappingFail,
    postDynatraceResourcePagerdutyMappingSuccess,
    postDynatraceResourcePagerdutyMappingFail,
    postDynatraceCreateResourceAlertsFail,
    postDynatraceCreateResourceAlertsSuccess,
    postDynatraceEnableDisableAlertsSuccess,
    postDynatraceEnableDisableAlertsFail,
    postDynatraceAlertFail,
    postDynatraceAlertSuccess,
    getDynatraceAlertsFail,
    getDynatraceAlertsSuccess,
    getDynatraceResourceByIdSuccess,
    getDynatraceResourceByIdFail,
    getMissingDynatraceAlertsByResourceIDSuccess,
    getMissingDynatraceAlertsByResourceIDFail,
    getDynatraceResourcesDefaultThresholdByIdFail,
    getDynatraceResourcesDefaultThresholdByIdSuccess,
    getDynatraceMissingDynamicAlertsFail,
    getDynatraceMissingDynamicAlertsSuccess,
    getDynatraceResourcesFail,
    getDynatraceResourcesSuccess,
    getDynatraceThresholdFail,
    getDynatraceThresholdSuccess, postEnableDisableDynatraceThresholdFail, postEnableDisableDynatraceThresholdSuccess,
    postUpdateDynatraceThresholdFail, postUpdateDynatraceThresholdSuccess,
    getDynatraceAllKeyUserActionsSuccess, getDynatraceAllKeyUserActionsFail,
    getDynatraceAllUserActionsFail, getDynatraceAllUserActionsSuccess,
    postCreateKeyUserActionFail, postCreateKeyUserActionSuccess,
} from "./actions"

import {
    getDynatraceAllResourceAlertsPageUrl,
    getDynatraceAllResourceAlertsCountPageUrl,
    getDynatraceResourceTypesUrl,
    postDynatraceServiceMappingUrl,
    postDynatraceResourceOpsgenieTeamMappingUrl,
    postDynatraceResourcePagerdutyServiceMappingUrl,
    postDynatraceCreateResourceAlertsUrl,
    getDynatraceRefreshUrl,
    getRescanStatusDynatraceUrl,
    getDynatraceMissingAlertByResourceIDUrl,
    postDynatraceEnableDisableAlertsUrl,
    getDynatraceResourceByIDUrl,
    getThresholdsDynatraceResourceByIDUrl,
    getMissingAlertsByResourceIDUrl, postDynatraceAlertUrl, getDynatraceAlertByResourceIdUrl,
    getDynatraceResourcesUrl, getDynatraceThresholdUrl, postEnableDisableDynatraceThresholdUrl,
    postUpdateDynatraceThresholdUrl,
    getDynatraceAllKeyUserActionPageUrl,
    getDynatraceAllUserActionPageUrl,
    postCreateKeyUserActionUrl,
} from "helpers/fakebackend_helper";

function* onGetDynatraceAllResourceAlertsPage({payload:data}) {
    try{
        const response = yield call(getDynatraceAllResourceAlertsPageUrl, data);
        yield put(getDynatraceAllResourceAlertsPageSuccess(response));
    } catch(error) {
        yield put(getDynatraceAllResourceAlertsPageFail(error))
    }
}

function* onGetDynatraceAllResourceAlertsCountPage({payload:data}) {
    try{
        const response = yield call(getDynatraceAllResourceAlertsCountPageUrl, data)
        yield put(getDynatraceAllResourceAlertsCountPageSuccess(response));
    } catch(error) {
        yield put(getDynatraceAllResourceAlertsCountPageFail(error))
    }
}

function* onGetDynatraceRescan() {
    try{
        const response = yield call(getDynatraceRefreshUrl)
        yield put(getDynatraceRefreshSuccess(response));
    } catch(error) {
        yield put(getDynatraceRefreshFail(error))
    }
}

function* onPostDynatraceServiceMapping({payload:data}) {
    try{
        const response = yield call(postDynatraceServiceMappingUrl, data)
        yield put(postDynatraceServiceMappingSuccess(response));
        window.location.reload();
    } catch(error) {
        yield put(postDynatraceServiceMappingFail(error))
    }
}

function* onPostDynatraceResourceOpsGenieTeamMapping({payload:data}) {
    try{
        const response = yield call(postDynatraceResourceOpsgenieTeamMappingUrl, data)
        yield put(postDynatraceResourceOpsGenieTeamMappingSuccess(response));
        window.location.reload();
    } catch(error) {
        yield put(postDynatraceResourceOpsGenieTeamMappingFail(error))
    }
}

function* onPostDynatraceResourcePagerdutyServiceMapping({payload:data}) {
    try{
        const response = yield call(postDynatraceResourcePagerdutyServiceMappingUrl, data)
        yield put(postDynatraceResourcePagerdutyMappingSuccess(response));
        window.location.reload();
    } catch(error) {
        yield put(postDynatraceResourcePagerdutyMappingFail(error))
    }
}

function* onGetAllOrgDynatraceResourceTypes() {
    try{
        const response = yield call(getDynatraceResourceTypesUrl)
        yield put(getAllOrgDynatraceResourceTypesSuccess(response));
    } catch(error) {
        yield put(getAllOrgDynatraceResourceTypesFail(error))
    }
}

function* onGetRescanStatusDynatrace() {
    try{
        const response = yield call(getRescanStatusDynatraceUrl)
        yield put(getRescanStatusDynatraceSuccess(response));
    } catch(error) {
        yield put(getRescanStatusDynatraceFail(error))
    }
}

function* onPostDynatraceCreateResourceAlerts({payload:data}) {
    try{
        const response = yield call(postDynatraceCreateResourceAlertsUrl, data)
        yield put(postDynatraceCreateResourceAlertsSuccess(response));
    } catch(error) {
        yield put(postDynatraceCreateResourceAlertsFail(error))
    }
}

function* onGetMissingAlertsByResourceID({payload:data}) {
    try{
        const response = yield call(getDynatraceMissingAlertByResourceIDUrl, data)
        yield put(getMissingDynatraceAlertsByResourceIDSuccess(response));
    } catch(error) {
        yield put(getMissingDynatraceAlertsByResourceIDFail(error))
    }
}

function* onGetDynatraceResourceById({payload:data}) {
    try{
        const response = yield call(getDynatraceResourceByIDUrl, data)
        yield put(getDynatraceResourceByIdSuccess(response));
    } catch(error) {
        yield put(getDynatraceResourceByIdFail(error))
    }
}

function* onGetDynatraceResourcesDefaultThresholdById({payload:data}) {
    try{
        const response = yield call(getThresholdsDynatraceResourceByIDUrl, data)
        yield put(getDynatraceResourcesDefaultThresholdByIdSuccess(response));
    } catch(error) {
        yield put(getDynatraceResourcesDefaultThresholdByIdFail(error))
    }
}

function* onPostDynatraceAlert({payload:data}) {
    try{
        const response = yield call(postDynatraceAlertUrl, data)
        yield put(postDynatraceAlertSuccess(response));
    } catch(error) {
        yield put(postDynatraceAlertFail(error))
    }
}

function* onGetAlertByResourceID({payload:data}) {
    try{
        const response = yield call(getDynatraceAlertByResourceIdUrl, data)
        yield put(getDynatraceAlertsSuccess(response));
    } catch(error) {
        yield put(getDynatraceAlertsFail(error))
    }
}

function* onGetDynatraceResources() {
    try{
        const response = yield call(getDynatraceResourcesUrl)
        yield put(getDynatraceResourcesSuccess(response));
    } catch(error) {
        yield put(getDynatraceResourcesFail(error))
    }
}

function* onGetDynatraceThreshold() {
    try{
        const response = yield call(getDynatraceThresholdUrl)
        yield put(getDynatraceThresholdSuccess(response));
    } catch(error) {
        yield put(getDynatraceThresholdFail(error))
    }
}

function* onPostEnableDisableAlerts({payload:data}) {
    try{
        const response = yield call(postDynatraceEnableDisableAlertsUrl, data)
        yield put(postDynatraceEnableDisableAlertsSuccess(response));
    } catch(error) {
        yield put(postDynatraceEnableDisableAlertsFail(error))
    }
}

function* onPostEnableDisableThreshold({payload:data}) {
    try{
        const response = yield call(postEnableDisableDynatraceThresholdUrl, data)
        yield put(postEnableDisableDynatraceThresholdSuccess(response));
    } catch(error) {
        yield put(postEnableDisableDynatraceThresholdFail(error))
    }
}

function* postUpdateDynatraceThreshold({payload:data}) {
    try{
        const response = yield call(postUpdateDynatraceThresholdUrl, data)
        yield put(postUpdateDynatraceThresholdSuccess(response));
    } catch(error) {
        yield put(postUpdateDynatraceThresholdFail(error))
    }
}

function* onGetAllKeyUserActions({payload:data}) {
    try{
        const response = yield call(getDynatraceAllKeyUserActionPageUrl, data)
        yield put(getDynatraceAllKeyUserActionsSuccess(response));
    } catch(error) {
        yield put(getDynatraceAllKeyUserActionsFail(error))
    }
}

function* onGetAllUserActions({payload:data}) {
    try{
        const response = yield call(getDynatraceAllUserActionPageUrl, data)
        yield put(getDynatraceAllUserActionsSuccess(response));
    } catch(error) {
        yield put(getDynatraceAllUserActionsFail(error))
    }
}

function* onPostCreateKeyUserAction({payload:data}) {
    try{
        const response = yield call(postCreateKeyUserActionUrl, data)
        yield put(postCreateKeyUserActionSuccess(response));
    } catch(error) {
        yield put(postCreateKeyUserActionFail(error))
    }
}

export function* dynatraceSaga() {
    yield takeEvery(GET_DYNATRACE_ALL_RESOURCE_ALERTS_PAGE, onGetDynatraceAllResourceAlertsPage)
    yield takeEvery(GET_DYNATRACE_ALL_RESOURCE_ALERTS_COUNT_PAGE, onGetDynatraceAllResourceAlertsCountPage)
    yield takeEvery(GET_DYNATRACE_RESCAN, onGetDynatraceRescan)
    yield takeEvery(POST_DYNATRACE_SERVICE_MAPPING, onPostDynatraceServiceMapping)
    yield takeEvery(POST_DYNATRACE_RESOURCE_OPSGENIE_TEAM_MAPPING, onPostDynatraceResourceOpsGenieTeamMapping)
    yield takeEvery(POST_DYNATRACE_RESOURCE_PAGERDUTY_SERVICE_MAPPING, onPostDynatraceResourcePagerdutyServiceMapping)
    yield takeEvery(GET_ALL_ORG_DYNATRACE_RESOURCE_TYPES, onGetAllOrgDynatraceResourceTypes)
    yield takeEvery(GET_RESCAN_STATUS_DYNATRACE, onGetRescanStatusDynatrace)
    yield takeEvery(POST_DYNATRACE_CREATE_RESOURCE_ALERTS, onPostDynatraceCreateResourceAlerts)
    yield takeEvery(GET_DYNATRACE_MISSING_ALERTS_BY_RESOURCE_ID, onGetMissingAlertsByResourceID)
    yield takeEvery(GET_DYNATRACE_RESOURCE_BY_ID, onGetDynatraceResourceById)
    yield takeEvery(GET_DYNATRACE_RESOURCE_DEFAULT_THRESHOLD_BY_ID, onGetDynatraceResourcesDefaultThresholdById)
    yield takeEvery(POST_DYNATRACE_ALERT, onPostDynatraceAlert)
    yield takeEvery(GET_DYNATRACE_ALERTS, onGetAlertByResourceID)
    yield takeEvery(GET_DYNATRACE_RESOURCES, onGetDynatraceResources)
    yield takeEvery(GET_DYNATRACE_THRESHOLD, onGetDynatraceThreshold)
    yield takeEvery(POST_DYNATRACE_ENABLE_DISABLE_ALERTS, onPostEnableDisableAlerts)
    yield takeEvery(POST_ENABLE_DISABLE_DYNATRACE_THRESHOLD, onPostEnableDisableThreshold)
    yield takeEvery(POST_UPDATE_DYNATRACE_THRESHOLD, postUpdateDynatraceThreshold)
    yield takeEvery(GET_DYNATRACE_ALL_KEY_USER_ACTIONS, onGetAllKeyUserActions)
    yield takeEvery(GET_DYNATRACE_ALL_USER_ACTIONS, onGetAllUserActions)
    yield takeEvery(POST_CREATE_KEY_USER_ACTION, onPostCreateKeyUserAction)
}
